import { render, staticRenderFns } from "./CyclopediaAnalysisCategoriesEditor.vue?vue&type=template&id=2973bcc4&scoped=true&"
import script from "./CyclopediaAnalysisCategoriesEditor.vue?vue&type=script&lang=js&"
export * from "./CyclopediaAnalysisCategoriesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973bcc4",
  null
  
)

export default component.exports